"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var single_widget_html_1 = __importDefault(require("./single-widget.html"));
require("./single-widget.less");
var angular_1 = require("angular");
(function (module) {
    function SingleWidgetController(
    // @ts-ignore
    $scope, 
    // @ts-ignore
    $routeParams, initService, flowingPages, pageLayout, 
    // @ts-ignore
    globalOptions, genericExportsService) {
        // @ts-ignore
        this.ready = false;
        // @ts-ignore
        var self = this;
        // @ts-ignore
        var widgetToExport;
        // @ts-ignore
        this.getWidgetStyles = function () {
            // @ts-ignore
            if (!widgetToExport) {
                return;
            }
            // @ts-ignore
            var layout = widgetToExport.layout;
            var cellSize = pageLayout.getCellSize();
            return {
                width: layout.colSpan * cellSize,
                height: layout.rowSpan * cellSize,
                padding: layout.padding || globalOptions.getWidgetPadding()
            };
        };
        initSingleWidget();
        function initSingleWidget() {
            initService.init();
            var singleWidgetId = $routeParams.widgetId;
            return initService.initSingleWidget(singleWidgetId).then(function () {
                widgetToExport = flowingPages.getWidget(singleWidgetId);
                flowingPages.ensureWidgetLayout(widgetToExport);
                $scope.widget = widgetToExport;
                genericExportsService.setupExport();
                initService.complete();
                self.ready = true;
            });
        }
    }
    SingleWidgetController.$inject = [
        '$scope',
        '$routeParams',
        'prInitService',
        'prFlowingPages',
        'prPageLayoutService',
        'pr.globalOptionsService',
        'pr.genericExportsService'
    ];
    module.component('prSingleWidget', {
        templateUrl: single_widget_html_1.default,
        controller: SingleWidgetController,
        controllerAs: 'swCtrl'
    });
})(angular_1.module('qualtrics.pr'));
